export function VerfahrenPage() {
  return (
    <div className="max-w-3xl mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Auktionsverfahren</h1>

      <section className="mb-8">
        <h2 className="text-xl font-serif mb-3">1. Registrierung und Einladung</h2>
        <p className="text-text-secondary leading-relaxed mb-4">
          Der Zugang zur Plattform erfolgt ausschließlich über personliche Einladungscodes.
          Diese werden von dem Patentinhaber nach Prüfung des potenziellen Interessenten vergeben.
          Jeder Code ist einmalig verwendbar und gilt nur fur die freigegebenen Auktionen.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-serif mb-3">2. Auktionsablauf</h2>
        <p className="text-text-secondary leading-relaxed mb-4">
          Die Auktionen werden als englische, aufsteigende Auktion mit anonymisierten Bietnummern
          durchgefuhrt. Jedes aktive Gebot muss mindestens um die festgelegte Mindestschrittweite
          über dem aktuellen Höchstgebot liegen.
        </p>
        <p className="text-text-secondary leading-relaxed mb-4">
          Gebote sind rechtsverbindlich und unwiderruflich. Innerhalb der letzten funf Minuten
          vor Auktionsende wird die Frist um weitere funf Minuten verlangert (Soft-Close),
          um ein strategisches Bieten in letzter Sekunde zu vermeiden.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-serif mb-3">3. Zuschlag und Compliance</h2>
        <p className="text-text-secondary leading-relaxed mb-4">
          Der Zuschlag erfolgt vorlaufig an den Hochstbietenden. Die endgultige Erteilung des
          Zuschlags ist abhangig vom Bestehen einer Compliance-Prifung. Details dazu finden Sie
          in unserer <a href="/compliance" className="">Compliance-Richtlinie</a>.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-serif mb-3">4. Datenschutz und Vertraulichkeit</h2>
        <p className="text-text-secondary leading-relaxed">
          Alle Teilnehmer sind zur Vertraulichkeit verpflichtet. Die Existenz und der Inhalt
          der Auktionen durfen nicht offentlich gemacht werden. Details dazu in den{' '}
          <a href="/agb" className="">AGB</a>.
        </p>
      </section>
    </div>
  );
}
